import React from "react";
import { EuiFlexGroup, EuiHideFor, EuiFlexItem } from "@elastic/eui";
import Drawer from "./drawer";
import Header from "./header/header";

import * as S from "./style";

function MainLayout({ children }) {
    return (
        <div>
            <Header />
            <S.FullscreenContentWrapper>
                <div className="drawer">
                    <Drawer />
                </div>

                <EuiFlexGroup>
                    <EuiFlexItem grow={false} />
                    <EuiFlexItem>{children}</EuiFlexItem>
                </EuiFlexGroup>
            </S.FullscreenContentWrapper>
        </div>
    );
}

export default MainLayout;
